export const RELOAD_CART_ITEMS = 'RELOAD_CART_ITEMS';

/**
 * This action is used to refresh all the items in the cart state
 * @param {array} items An array of variant item objects with the same properties as in ADD_CART_ITEM
 * @returns An action object of the specified type and payload
 */

const reloadCartItems = (items = []) => {
    return {
        type: RELOAD_CART_ITEMS,
        payload: { items },
    };
};

export default reloadCartItems;